<template>
  <div class="home">
    <div class="minehead">
      <div class="changename">
        <img @click="toUserMes" class="headPic" src="../assets/headPic.png" />
        <div class="phoneNum" @click="toUserMes">
          {{ userMes.phone || "尚未登录" }}
        </div>
        <div @click="toLogin" v-if="userMes.phone" class="changePhone">
          <img src="../assets/tclogin.png" alt="" />
        </div>
      </div>
    </div>
    <!-- <img @click="toequity" style="width: 94%; margin: 0px auto 10px" src="../assets/banner2.png" /> -->
    <div class="vipcss">
      <div>
        <img v-if="userMes.paperVip" src="../assets/mine/vip2.png" alt="" />
        <img v-else src="../assets/mine/vip.png" alt="" />
        <div class="absolute" v-if="userMes.paperVip">
          <div style="font-size: 13px; color: #fff">
            {{ userMes.paperVip.vipName }}
          </div>
          <div>{{ userMes.vipExpireTime }}</div>
        </div>
      </div>
      <div class="dingwei">
        <!-- <div class="vipimg" v-if="userMes.paperVip" @click="vipTo">
          {{ userMes.exchangeCount }}张兑书卡
        </div> -->
        <div class="vipimg" v-if="!userMes.paperVip" @click="vipTo">立即开通</div>
        <div class="tuiding" v-show="userMes.signCount > 0" @click="tuiding">
          取消自动续费
        </div>
      </div>
    </div>
    <div class="container">
      <div class="icon-grid">
        <div class="icon-item" v-for="item in iconList" :key="item.id" @click="handleIconClick(item)">
          <div class="icon-box">
            <img class="icon-image" :src="item.icon" mode="aspectFit" />
          </div>
          <span class="icon-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="mineList">
      <div @click="toAddress" class="eachBlock">
        <div class="eachIco">
          <img src="../assets/mineIco4.png" />
        </div>
        <span class="eachTit">地址</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div>
      <div v-if="isShowService" @click="toService" class="eachBlock">
        <div class="eachIco">
          <img style="width: 0.44rem" src="../assets/mineIco5.png" />
        </div>
        <span class="eachTit">客服</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div>
      <div @click="toCdKey" class="eachBlock" v-if="vipType != 0">
        <div class="eachIco">
          <img src="../assets/mineIco6.png" />
        </div>
        <span class="eachTit">卡密兑换</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div>
      <div @click="tovipEquity" class="eachBlock" v-if="beiandata == '浙ICP备2021005120号-5'">
        <div class="eachIco">
          <img style="width: 0.5rem" src="../assets/mineIco8.png" />
        </div>
        <span class="eachTit">会员领取</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div>
      <!-- <div @click="toJl" class="eachBlock" v-if="vipType != 0">
        <div class="eachIco">
          <img style="width: 0.5rem" src="../assets/jl.png" />
        </div>
        <span class="eachTit">生成记录</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div> -->
      <el-drawer size="16%" direction="btt" title="我是标题" :visible.sync="drawer" :with-header="false">
        <div class="kf">
          <div @click="kf(1)" style="border-bottom: 1px solid #0000001a">
            客服电话
          </div>
          <div @click="kf(2)">在线客服</div>
        </div>
      </el-drawer>

      <!-- <div @click="tovipEquity" class="eachBlock" v-if="vipType != 0">
        <div class="eachIco">
          <img style="width: 0.45rem;" src="../assets/mineIco8.png" />
        </div>
        <div class="eachTit" style="margin-top:4.8px;">会员领取</div>
        
      </div> -->
    </div>
    <div class="beian" v-if="kfshow == false" @click="beian">
      {{ beiandata }}
    </div>
    <FootTab></FootTab>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";
import wx from "weixin-js-sdk";
import axios from "axios";

import VConsole from "../../src/api/vconsole.min.js";
var hjState = 1;
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      title: "",
      vipType: "1",
      userMes: [],
      isShowService: false,
      drawer: false,
      kfshow: false,
      beiandata: localStorage.getItem("beiantext"),
      iconList: [
        {
          id: 1,
          text: "会员",
          icon: require("../assets/mine/hy.png"),
          bgColor: "#e6f7ff",
        },
        {
          id: 2,
          text: "生成记录",
          icon: require("../assets/mine/jl.png"),
          bgColor: "#e6f7ff",
        },
        {
          id: 3,
          text: "订单",
          icon: require("../assets/mine/dd.png"),
          bgColor: "#e6f7ff",
        },
      ],
    };
  },
  created() {
    if (window.location.href.indexOf("iread") == -1) {
      this.isShowService = true;
    }
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let phone = params.get("phone");
    if (phone) {
      if (phone.length == 11) {
        this.http.avoidlogin({ phone: phone }).then((res) => {
          if (res.data.status == 1) {
            this.userMes = res.data.data;
            this.status = res.data.status;
            localStorage.setItem("userMes", JSON.stringify(res.data.data));
          }
        });
      }
    }
    const ua = navigator.userAgent.toLowerCase();
    // 微信小程序环境
    if (ua.match(/miniprogram/i)) {
      this.kfshow = true;
    }

    if (location.href.indexOf("hemakouyu") != -1) {
      localStorage.setItem("kfphone", "4009933950");
    } else {
      localStorage.setItem("kfphone", "4008888202");
    }
  },
  mounted() {
    // new VConsole();
    this.vipType = localStorage.getItem("vipType");
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let token = params.get("token");
    let openId = params.get("openId");
    let originUrl = params.get("originUrl");
    let AGRMNO = params.get("AGRMNO");
    if (AGRMNO != "") {
      if (originUrl != null) {
        window.location.href = originUrl;
      }
    }
    console.log(token, "token");
    console.log(openId, "openId");
    if (openId != null || openId != undefined) {
      localStorage.setItem("openId", openId);
    }
    if (token != null) {
      localStorage.setItem("userMes", JSON.stringify({ user_token: token }));
    }
    // 获取用户信息
    this.http.getUserMes().then((res) => {
      console.log(res, "用户详情");
      if (res.data.status == 1) {
        if (token != null) {
          res.data.data.user_token = token;
          localStorage.setItem("userMes", JSON.stringify(res.data.data));
        }
        this.userMes = res.data.data;
        this.status = res.data.status;
      }
    });
  },
  methods: {
    tuiding() {
      let data = {
        appkey: "zxs001",
        bizcode: "wechat_sign_cancle",
        sign: "byt",
        phone: this.userMes.phone,
        productId: this.userMes.paperVip.productId,
      };
      if (hjState == 0) {
        data.productId = this.userMes.paperVip.miniProductId;
      } else if (hjState == 1) {
        data.productId = this.userMes.paperVip.jsapiProductId;
      } else {
        data.productId = this.userMes.paperVip.productId;
      }
      if (
        this.userMes.paperVip.vipCode == "guoshou29" ||
        this.userMes.paperVip.vipCode == "guoshou29-2"
      ) {
        data.bizcode = "tl_unSign_service";
      }
      axios
        .post("https://jifei.aizhishifm.com/rest/open/exec", data)
        .then((response) => {
          console.log("请求成功:", response.data);
          if (response.data.flag == true) {
            this.$message({
              message: "退订成功",
              type: "success",
            });
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          console.error("请求失败:", error);
        });
    },

    beian() {
      window.location.href = "https://beian.miit.gov.cn";
    },
    toJl() {
      this.$router.push({ name: "records", query: { type: "3" } });
    },
    vipTo() {
      if (this.userMes.phone) {
        this.$router.push({ name: "vip" });
      } else {
        this.wxState();
      }
    },
    handleIconClick(item) {
      if (item.id == 1) {
        if (this.userMes.phone) {
          this.$router.push({ name: "mineVip" });
        } else {
          this.wxState();
        }
      } else if (item.id == 2) {
        this.toJl()
        // this.$router.push({ name: "car" });
      } else {
        if (this.userMes.phone) {
          this.$router.push({ name: "mineOrder" });
        } else {
          this.wxState();
        }
      }
    },
    toCar() {
      this.$router.push({ name: "car" });
    },
    tovipEquity() {
      if (this.userMes.phone) {
        this.$router.push({ name: "vipEquity" });
      } else {
        this.wxState();
      }
    },
    mineVip() {
      if (this.userMes.phone) {
        this.$router.push({ name: "mineVip" });
      } else {
        this.wxState();
      }
    },
    toMineOrder() {
      if (this.userMes.phone) {
        this.$router.push({ name: "mineOrder" });
      } else {
        this.wxState();
      }
    },
    toBookCard() {
      if (this.userMes.phone) {
        this.$router.push({ name: "bookCard" });
      } else {
        this.wxState();
      }
    },
    toAddress() {
      if (this.userMes.phone) {
        sessionStorage.setItem("fromPath", "");
        this.$router.push({ name: "address" });
      } else {
        this.wxState();
      }
    },
    toService() {
      //true 微信小程序客服 false h5直接拨打电话
      if (this.kfshow) {
        this.drawer = true;
        return;
      } else {
        window.location.href = `tel:${localStorage.getItem("kfphone")}`;
      }
    },
    kf(item) {
      if (item == 1) {
        window.location.href = `tel:${localStorage.getItem("kfphone")}`;
      } else {
        let a = localStorage.getItem("openId");
        if (a == null || a == undefined) {
          this.wxState();
          return;
        }
        this.$router.push({ name: "kf" });
      }
    },
    toCdKey() {
      if (this.userMes.phone) {
        this.$router.push({ name: "cdKey" });
      } else {
        this.wxState();
      }
    },
    toUserMes() {
      if (this.userMes.phone) {
        // this.$router.push({ name: "userMes" });
      } else {
        // sessionStorage.setItem("loginReturn",window.location.href)
        // this.$router.push({name: "login"})
        this.wxState();
      }
    },
    toequity() {
      this.$router.push({ name: "equity" });
    },
    toLogin() {
      localStorage.removeItem("openId");
      if (this.userMes.phone) {
        // 退出登录
        this.http.loginOut().then((res) => {
          this.userMes = [];
          if (res.data.data) {
            window.location.href = res.data.data;
          } else {
            this.wxState();
          }
        });
      } else {
        this.wxState();
      }
    },
    getVipUrl(url) {
      if (!this.isLiantong) {
        return;
      }
      if (this.userMes.phone) {
        var that = this;
        // 获取vip地址
        this.http
          .getVipUrl({
            redirectUri: url,
          })
          .then((res) => {
            if (res.data.status == 1) {
              window.location.href = res.data.msg;
            } else {
              that.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      } else {
        this.wxState();
      }
    },
    wxState() {
      let that = this;
      let state = false; //是否嵌套在小程序里
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram == true) {
          state = true;
        }
      });
      if (state == true) {
        // console.log("我在小程序中");
        wx.miniProgram.navigateTo({ url: "/pages/login/login" });
      } else {
        // console.log("我在网页中");
        sessionStorage.setItem("loginReturn", window.location.href);
        that.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tuiding {
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  color: #ababab;
  font-size: 12px;
}

.absolute {
  position: absolute;
  left: 23%;
  bottom: 10%;
  color: #a4a4a4;
  line-height: 20px;
  font-size: 12px;
}

.beian {
  text-align: center;
  font-size: 12px;
  position: fixed;
  bottom: 11%;
  left: 0;
  right: 0;
  color: #656565;
}

.dingwei {
  position: absolute;
  height: fit-content;
  right: 23px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.home {
  background-color: #f6f6f6;
  min-height: 100vh;
  padding-bottom: 1.46rem;
  text-align: left;

  .vipcss {
    width: 94%;
    margin: auto;
    position: relative;

    .vipimg {
      // width: 80px;
      padding: 0 10px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 10px;
      color: black;
      background-color: #acdbff;
    }
  }

  .minehead {
    height: 2.93rem;
    // background-image: url(../assets/mineHeadBg.png);
    background: #e9f0f7;
    background-size: cover;
    position: relative;

    .changename {
      position: absolute;
      left: 0;
      right: 0;
      top: 0.5rem;
      display: flex;
      align-items: center;
    }

    .changePhone {
      width: 16px;
      height: 16px;
      font-size: 0.24rem;
      text-align: center;
      margin-left: 1.8rem;
      margin-top: 0.28rem;
    }

    .headPic {
      width: 1.46rem;
      height: 1.46rem;
      margin: 0px 0px 0 20px;
      padding-top: 0.4rem;
      box-sizing: content-box;
    }

    .phoneNum {
      text-align: center;
      font-size: 0.32rem;
      color: #222222;
      margin-top: 0.28rem;
      padding-left: 0.3rem;
    }

    .botVip {
      height: 1.3rem;
      width: 100%;
      position: absolute;
      bottom: 0.13rem;
      left: 0;
    }

    .botVip img {
      width: 3.16rem;
      height: 100%;
    }
  }

  .mineList {
    padding: 0 8px;
    margin: 14px 0.29rem 0px 0.24rem;
    background: #fff;
    border-radius: 10px;

    .eachBlock {
      height: 1.09rem;
      line-height: 1.06rem;
      position: relative;

      .eachIco {
        display: inline-block;
        vertical-align: middle;
        width: 0.78rem;

        img {
          width: 22px;
          height: 22px;
          display: block;
          margin: 0px auto;
        }
      }

      .eachTit {
        font-size: 0.32rem;
        color: #616161;
        display: inline-block;
        vertical-align: middle;
      }

      .arrow {
        position: absolute;
        right: 0.37rem;
        top: 0.42rem;
        width: 0.14rem;
        height: 0.24rem;
      }
    }
  }
}

.kf {
  text-align: center;
}

.kf div {
  height: 50px;
  line-height: 50px;
}

.container {
  padding: 5px 0 12px;
  background-color: #ffffff;
  width: 94%;
  margin: auto;
  border-radius: 10px;
}

.icon-grid {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 23%;
}

.icon-box {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}

.icon-image {
  width: 100%;
  height: 100%;
}

.icon-text {
  font-size: 12px;
  color: #333333;
  text-align: center;
}
</style>
